<div class="listing">
    <div class="item-2 mb-5">
        <app-product-thumbnail [isBig]="true" [product]="firstProduct" />
    </div>
    <div class="item-3">
        <div class="row">
            @for (product of restOfProducts; track product) {
                <div class="col-4 mb-5">
                    <app-product-thumbnail [isBig]="false" [product]="product" />
                </div>
            }
        </div>
    </div>
</div>
